import React, { useState } from "react";

const data = [
  {
    id: 1,
    badge: "1 profile intake",
    title: "Get Started in Minutes",
    content:
      "Share your resume, target roles, preferred locations, and timeline. A Career Manager turns that into a focused job search strategy.",
  },
  {
    id: 2,
    badge: "ATS-focused drafts",
    title: "Optimized Resumes for Every Job",
    content:
      "Lovapex builds ATS-ready resume versions that highlight the right skills and match the language of the roles you want.",
  },
  {
    id: 3,
    badge: "Managed outreach",
    title: "We Apply and Follow Up for You",
    content:
      "The team manages applications, LinkedIn outreach, recruiter follow-ups, and tracking so your search keeps moving every week.",
  },
  {
    id: 4,
    badge: "Weekly reporting",
    title: "Stay Updated Every Step",
    content:
      "Weekly updates show applications sent, responses received, interviews scheduled, and the next adjustments to improve momentum.",
  },
];

const HowToWorkSection = () => {
  const [tab, setTab] = useState(1);

  return (
    <section className="section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">How It Works</p>
          <h2>Your journey to getting hired, simplified.</h2>
          <p>Move from scattered applications to a clear operating rhythm.</p>
        </div>
        <div className="journey-panel">
          <div className="tab-list" role="tablist" aria-label="Lovapex process">
            <button
              className={tab === 1 ? "active" : ""}
              type="button"
              role="tab"
              aria-selected="true"
              onClick={() => setTab(1)}
            >
              Onboard
            </button>
            <button
              className={tab === 2 ? "active" : ""}
              type="button"
              role="tab"
              aria-selected="false"
              onClick={() => setTab(2)}
            >
              Resume Review
            </button>
            <button
              className={tab === 3 ? "active" : ""}
              type="button"
              role="tab"
              aria-selected="false"
              onClick={() => setTab(3)}
            >
              Smart Outreach
            </button>
            <button
              className={tab === 4 ? "active" : ""}
              type="button"
              role="tab"
              aria-selected="false"
              onClick={() => setTab(4)}
            >
              Track Progress
            </button>
          </div>
          <section className="card tab-card">
            <span className="badge badge-teal">{data[tab - 1].badge}</span>
            <h3>{data[tab - 1].title}</h3>
            <p>{data[tab - 1].content}</p>
            <div className="mini-dashboard">
              <div>
                <span>Strategy</span>
                <strong>Ready</strong>
              </div>
              <div>
                <span>Outreach</span>
                <strong>Active</strong>
              </div>
              <div>
                <span>Updates</span>
                <strong>Weekly</strong>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default HowToWorkSection;
